import { render, staticRenderFns } from "./Appuntamento.vue?vue&type=template&id=fc116ad6"
import script from "./Appuntamento.vue?vue&type=script&lang=js"
export * from "./Appuntamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports